export default "../css/5f909b9cae0166aa847329cacac79719.ttf";